"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import styles from '../ProgressBar.module.scss.mjs';
import 'react';
import { getCategoricalColorByIndex } from '../../../lib/tokens/getCategoricalColorByIndex.mjs';

const ProgressBarBar = (props) => {
  const { segments, segmentsTotalValue, percentage } = props;
  return /* @__PURE__ */ jsx("div", { className: styles.bar, children: /* @__PURE__ */ jsx("div", { className: styles.fill, style: { width: percentage + "%" }, children: segments && segmentsTotalValue && segments.map((s, i) => /* @__PURE__ */ jsx(
    "div",
    {
      "aria-hidden": true,
      style: {
        backgroundColor: `var(--color--categorical--${s.color ?? getCategoricalColorByIndex(i)})`,
        width: 100 / segmentsTotalValue * s.value + "%",
        height: "100%"
      }
    },
    s.title
  )) }) });
};

export { ProgressBarBar };
//# sourceMappingURL=ProgressBarBar.mjs.map
